import {
  Button,
  createStyles,
  Typography,
  WithStyles,
  withStyles,
} from '@material-ui/core'
import ErrorIcon from '@material-ui/icons/ErrorOutline'
import * as React from 'react'

import { t } from '../i18n'

import { ErrorRenderProps } from './Fetcher'
import Flex from './Flex'
import Margin from './Margin'

const styles = createStyles({
  root: {
    height: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

type Props = ErrorRenderProps & WithStyles<typeof styles>

const CalendarError: React.FunctionComponent<Props> = ({
  classes,
  children,
  refresh,
}) => (
  <Margin top={10}>
    <Flex
      justify={'flex-start'}
      alignItems={'center'}
      fullWidth={true}
      className={classes.root}
    >
      <div className={classes.content}>
        <Margin right>
          <ErrorIcon color="error" />
        </Margin>
        <Typography variant="subtitle1">{children}</Typography>
      </div>
      {refresh && (
        <div className={classes.content}>
          <Button variant="contained" color="primary" onClick={refresh}>
            {t('Réessayer')}
          </Button>
        </div>
      )}
    </Flex>
  </Margin>
)

export default withStyles(styles)(CalendarError)
